import { render, staticRenderFns } from "./RouterViewComponent.vue?vue&type=template&id=69f711b8"
import script from "./RouterViewComponent.vue?vue&type=script&lang=js"
export * from "./RouterViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports